export const AI_AGENTS = [
    { name: 'Claire', description: '', img: '/assets/agents/claire-agent-icon.svg' },
]